<div class="copilot-home-container">
    @if (isGeneratingDeck) {
        <div class="strategy-deck-generating-banner">
            <app-spinner-icon class="strategy-deck-generating-spinner"></app-spinner-icon>
            <span>Generating your Strategy Deck...</span>
        </div>
    }
    @if (isWizardOpen) {
        <app-wizard [wizard]="wizards[selectedWizardIndex]" (submitWizard)="onWizardSubmit($event)" (exitWizard)="closeWizard()"></app-wizard>
    } @else if (isStrategyDeckOpen) {
        <app-strategy-deck (submitWizard)="onStrategyDeckSubmit($event)" (exitWizard)="closeStrategyDeck()"></app-strategy-deck>
    } @else {
    <div class="copilot-screen-header">
        <span>Hey {{ userFirstName() }}, let's plan</span><span class="copilot-screen-header-highlight"> together</span>
    </div>
    <div class="copilot-home-prompt-bar-wrapper">
        <app-copilot-prompt-bar
            [promptControl]="promptControl"
            [showModelSelector]="canSelectV2"
            [selectedModel]="selectedModelVersion()"
            (modelChange)="onModelVersionChange($event)"
            (sendMessage)="onSendMessage($event)">
        </app-copilot-prompt-bar>
    </div>
    <div class="copilot-home-brand-selection" *ngIf="!isExpiredUser">
        <app-two-stage-brand-picker
            [placeholderText]="'Select brands for tailored answers'"
            [competitorSelectionText]="'Select competitors for comparison'">
        </app-two-stage-brand-picker>
    </div>
    <app-suggested-questions (questionSelected)="onQuestionSelected($event)"></app-suggested-questions>
    <div class="copilot-home-wizard-tiles-container">
        <div class="alert-center-wizard"
            [matTooltip]="!hasAlertCenterPermissions ? tooltips.sideMenu.unauthorizedTab : null"
            matTooltipClass="tooltip-with-triangle">
            <app-copilot-wizard-tile
                [isExpiredUser]="isExpiredUser"
                [iconPath]="'svg/bell.svg'"
                [title]="'Alert Center'"
                [description]="'See where your competitors are winning, and why'"
                (click)="openAlertCenter()">
            </app-copilot-wizard-tile>
        </div>
        <div class="strategy-deck-wizard">
            <app-copilot-wizard-tile
                [isExpiredUser]="isExpiredUser"
                [iconPath]="'svg/strategy-deck-white.svg'"
                [title]="'Strategy Deck'"
                [description]="'Turn competitive insights into a client-ready sales presentation'"
                (click)="openStrategyDeck()">
            </app-copilot-wizard-tile>
        </div>
        <app-copilot-wizard-tile
            *ngFor="let wizard of wizards.slice(0, numberOfWizardTiles); let i = index"
            [isExpiredUser]="isExpiredUser"
            [iconPath]="wizard.tileSvg"
            [title]="wizard.title"
            [description]="wizard.description"
            (click)="openWizard(i)">
        </app-copilot-wizard-tile>
    </div>
    }
</div>
